<div class="dashboard">
    <div class="banner">
        <las-banner></las-banner>
    </div>
    <div class="left-dash-panel">
        <las-user-assignments class="mat-elevation-z1"
            >Assignments</las-user-assignments
        >
    </div>
    <div class="right-dash-panel">
        <las-resources class="mat-elevation-z1">Resources</las-resources>
        <las-list
            heading="Personal Lists"
            type="personal"
            [canEdit]="true"
        ></las-list>
        <las-list
            heading="Shared Lists"
            type="shared"
            [canEdit]="false"
        ></las-list>
        <!--We need to update the edit field for this based on the user's role.-->
        <las-list
            heading="Department Lists"
            type="department"
            [canEdit]="isAdmin"
        ></las-list>
    </div>
</div>
